
import Model from './model';
import config from './../config';

import state from './../zviz2/zviz/state';
import {mapdata} from './../components/map/mapdata';
import ModelCollection from './../zviz2/zviz/modelcollection'
import {extend} from './../zviz2/zviz/functions';

class Flow extends Model{

    constructor(name=null, settings={}){
        settings = extend(settings, {
            endpoint: config.root + 'amounts',
            method: 'GET',
            listeners: [
                (model) => ( model.addListener(state, [model, model.update], 'filter') ),
                (model) => ( model.addListener(state, [model, model.update], 'source') )
            ]
        });
        
        super(name, settings);

        this.cache = new Map();

        this.regionMap = {
            'Africa': 'African Region',
            'Asia': 'Asian and the Pacific Region',
            'Asia and the Pacific': 'Asian and the Pacific Region',
            'Middle East': 'Arab States Region',
            'Arab States': 'Arab States Region',
            'Europe': 'European Region',
            'Europe and Central Asia': 'European Region',
            'Latin America': 'Inter American Region',
            'Americas': 'Inter American Region'
        };

        // This mapping is replaced with some logic in mapCountryValue. Leaving it here for reference.
        // It's also referenced in the countries controller
        this.countryMap = {
            // 'Congo': 'CD',
            // 'Congo (Democtatic Republic of)': 'CD',  // two names for the same country...? Not good!
            // 'Côte d\'ivoire': 'CI',
            // 'South Africa           SAFR': 'ZA',    // yes... this is weird
            // 'Tanzania, United Rep. of': 'TZ',
            // 'East Timor': 'TL',
            // 'Lao People\'s Dem Rep': 'LA',
            // 'Viet-Nam': 'VN',
            // 'Arab Occupied Territories': 'PS',
            // 'Moldova, Republic of': 'MD',
            // 'Serbia and Montenegro': 'RS', // Note RS is only Serbia
            // 'Kazakstan': 'KZ',
            // 'Macedonia the f y Rep of': 'MK',
            // 'Occupied Palestinian Territories': 'PS',
            // 'North Macedonia': 'MK',
            // 'Türkiye': 'TR'
        };
        

        this.items = {};
        this.links = new Map();
        this.dimensionRegion = 'region';
        this.dimensionTheme = 'theme';

        this.update();

    }
    
    getSelect(){
        let f = state.get('filter') || {};
        f['planned_flag'] = true; // set the right value in processFilter
        if(f.year){
            f['eval_rpt_end_year'] = f.year.slice(0);
            delete f.year;
        }
        let input = {'filter': this.processFilter(f)};
        this.processSearch(input, f);
        
        input['aggregateBy'] = this.getDimensions().join(',');

        let source = state.get('source');

        if(source == 'll'){
            input['countField'] = 'll_id';
        }else if(source == 'gp'){
            input['countField'] = 'gp_id';
        }else if(source == 'rec'){
            input['countField'] = 'rec_id';
        }else{
            input['countField'] = 'eval_id';
        }
        input['returnLinks'] = true;

        return input;
    } 

    getDimensions(){
        let dimRegion = 'country';
        let v = state.get('filter.country');
        if(! v || v == null && v != ''){
            v = state.get('filter.region');
            if(! v || v == null && v != ''){
                dimRegion = 'region';
            }
        }

        const source = state.get('source');
        let dimTheme = source === 'eval' || source === 'planned' ? 'theme' : source + '_theme';
        v = state.get('filter.' + dimTheme);
        if(! v || v == null && v != ''){
            v = state.get('filter.' + dimTheme + '_category');
            if(! v || v == null && v != ''){
                dimTheme = dimTheme + '_category';
            }
        }

        this.dimensionRegion = dimRegion;
        this.dimensionTheme = dimTheme;

        return [dimTheme, dimRegion];
    }


    mapRegionValue(input){
        if(this.regionMap[input]){
            return this.regionMap[input];
        } 
        return input;
    }

    mapCountryValue(input){
        // Mapping some variants of country names to the one use in the mapdata
        if(input.includes('Palestin')){
            return 'State of Palestine';
        }else if(input.includes('Bahamas')){
            return 'The Bahamas';
        }else if(input.includes('Bolivia')){
            return 'Bolivia';
        }else if(input.includes('Cabo Verde')){
            return 'Cape Verde';
        }else if(input.includes('Ivoire')){
            return 'Cote d\'Ivoire';
        }else if(input.includes('Kosovo')){
            return 'Kosovo';
        // Serbia and Montenegro used to be one country, now only Serbia is in the map
        }else if(input.includes('Serbia')){
            return 'Serbia';
        }else if(input.includes('Timor')){ // matching for Timor-Leste and East Timor
            return 'Timor-Leste';
        }else if(input.includes('Macedonia')){ // the value in the database has a trailing space...
            return 'North Macedonia';
        }

        return input;
    }

    getDataFromResponse(input){

        input = super.getDataFromResponse(input);
        if(input == null){
            return null;
        }

        let result = {items: {}, links: null};
        if(input['items']){
            result.items = {};
            for(let key of Object.keys(input['items'])){
                let k = key;
                result.items[k] = [];
                for(let item of input['items'][k]){
                    let v = item['v'];
                    let a = parseInt(item['a'], 10);
                    if(a > 0){
                        result.items[k].push({
                            value: v,
                            amount: a
                        });
                    }
                }                   
            }
        }

        if(input['links']){
            //result.links = [];
            this.links = new Map();
            for(let key of Object.keys(input['links'])){
                let k = key;
                for(let item of input['links'][k]){
                    let l1 = k + '=' + item['c1'];
                    let l2 = item['type'] + '=' + item['c2'];
                    let a = parseInt(item['a'], 10);
                    if(a > 0){
                        this.links.set(l1 + '|' + l2, a);
                        this.links.set(l2 + '|' + l1, a);
                    }
                }
            }
            result.links = this.links;
        }

        this.items = result.items;

        return result;
    }

    getCache(){
        let success = super.getCache();
        if(success){
            this.items = this.data.items;
            this.links = this.data.links;
        }
        return success;
    }

    getLink(dim1, val1, dim2, val2){
        let l1 = dim1 + '=' + val1;
        let l2 = dim2 + '=' + val2;
        return this.links.get(l1 + '|' + l2);
    }

    getLinks(dim, val){
        let result = [];
        let name = dim + '=' + val;
        for(let [d, a] of this.links){
            if(d.split('|')[0] == name){
                let v = d.split('|')[1].split('=');
                result.push({dimension: v[0], value: v[1], amount: a});
            }
        }
        return result;
    }

}

ModelCollection.setModelClass('flow', Flow);

export default Flow;